import React, { useState } from 'react';
import { MessageCircle } from 'react-feather';

import ButtonAction from '../ButtonAction';
import ModalAnswer from './ModalAnswerNew';

const YourAnswer = () => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <ButtonAction
        icon={<MessageCircle />}
        text="Your answer"
        onClick={() => setOpen(true)}
      />
      <ModalAnswer
        toggleModal={() => {
          setOpen(false);
        }}
        open={open}
      />
    </div>
  );
};

export default YourAnswer;
